module.exports = __webpack_public_path__ + "static/media/matapacos.665712ea.png";